export default "__VITE_ASSET__8602692f__"